import { markRaw } from 'vue'

export default {
  setModulesPermissions (payload) {
    this.adminModulesPermissions = markRaw(payload.map(permission => ({
      name: permission.module_name,
      ablePublish: permission.ablePublish === 1,
      geolocation: permission.geolocation === 1,
      subpermission: permission.scope,
      franchiseId: permission.franchise_id || null
    })))
  }
}
